export default "__VITE_ASSET__D08j1QFa__"